import { normalizeStatus } from "../utils/sipHelpers";

export const COMPLEX_EDIT_FIELDS = ["name", "city", "status", "developer"];

export const COMPLEX_EDIT_LABELS = {
  name: "Название",
  city: "Город",
  status: "Статус",
  developer: "Застройщик",
};

export function createComplexDraft(complex) {
  return {
    ...Object.fromEntries(COMPLEX_EDIT_FIELDS.map((field) => [field, String(complex?.[field] ?? "")])),
    status: normalizeStatus(complex?.status),
  };
}

export function buildComplexPatch(original, draft) {
  const patch = {};
  COMPLEX_EDIT_FIELDS.forEach((field) => {
    if (field === "status") {
      const originalStatus = normalizeStatus(original?.status);
      if (Boolean(draft?.status) !== originalStatus) patch.status = Boolean(draft?.status);
      return;
    }
    const value = String(draft?.[field] ?? "").trim();
    if (value === String(original?.[field] ?? "").trim()) return;
    patch[field] = value;
  });
  return patch;
}

export function applyBulkComplexResults(complexes, results) {
  const patches = new Map(results.filter((item) => item.ok).map((item) => [item.complexId, item.complex]));
  return complexes.map((complex) => patches.has(String(complex._id)) ? { ...complex, ...patches.get(String(complex._id)) } : complex);
}
